// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dayplan-container {
    padding: 20px;
    background: #f9f9f9;
    min-height: 100vh;
  }
  
  .dayplan-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 40vh;
    gap: 12px;
    color: #64748b;
    font-size: 0.95rem;
  }
  
  .dayplan-empty {
    min-height: 40vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 24px 16px;
    color: #64748b;
  }
  
  .dayplan-empty-icon {
    font-size: 2.5rem;
    margin-bottom: 8px;
  }
  
  .dayplan-empty-title {
    font-size: 1.3rem;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 4px;
  }
  
  .dayplan-empty-text {
    font-size: 0.95rem;
    max-width: 420px;
  }
  
  .page-title {
    font-size: 26px;
    font-weight: bold;
    color: #4a47a3;
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
    text-align: center;
  }
  
  .custom-accordion {
    max-width: 600px;
    margin: 0 auto;
  }
  
  .accordion-item {
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 10px;
    border: none;
  }
  
  .accordion-header {
    color: white;
    font-weight: bold;
    padding: 15px;
    font-size: 18px;
    text-transform: uppercase;
    border-radius: 10px;
    transition: 0.3s;
  }
  
  .accordion-header:hover {
    background:  #2ee543;
  }
  
  .accordion-body {
    background: white;
    padding: 15px;
    border-radius: 10px;
  }
  
  /* 🟡 Vibrant Lesson Card */
  .lesson-card {
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 15px;
    transition: 0.3s;
  }

  /* 🔵 Random Background Colors */
  .lesson-card:nth-child(1) { background: #ffebf0; } /* Light Pink */
  .lesson-card:nth-child(2) { background: #e0f7fa; } /* Light Blue */
  .lesson-card:nth-child(3) { background: #fff3e0; } /* Light Orange */
  .lesson-card:nth-child(4) { background: #f3e5f5; } /* Light Purple */
  .lesson-card:nth-child(5) { background: #e8f5e9; } /* Light Green */

  /* 🟠 Hover Effect */
  .lesson-card:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
  
  /* 🎨 Lesson Title */
  .lesson-title {
    color: #d81b60;
    font-size: 20px;
    font-weight: bold;
  }
  
  /* 📝 Lesson Plan */
  .lesson-plan {
    font-size: 16px;
    font-weight: 500;
    color: #444;
    /* text-align: center; */
    padding: 10px 15px;
    border-left: 5px solid #ff6b6b;
    background: linear-gradient(135deg, #fdfbfb, #ebedee);
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-top: 10px;
    transition: all 0.3s ease-in-out;
}

/* 🔥 Hover Effect */
.lesson-plan:hover {
    transform: scale(1.02);
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
}

/* 🌀 Randomized Colors */
.lesson-card:nth-child(1) .lesson-plan { border-left-color: #ff6b6b; }
.lesson-card:nth-child(2) .lesson-plan { border-left-color: #4caf50; }
.lesson-card:nth-child(3) .lesson-plan { border-left-color: #ff9800; }
.lesson-card:nth-child(4) .lesson-plan { border-left-color: #3f51b5; }
.lesson-card:nth-child(5) .lesson-plan { border-left-color: #e91e63; }

.image-upload-section {
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

.image-upload {
  text-align: center;
}

.preview-image {
  width: 150px;  /* Adjust width as needed */
  height: 150px; /* Adjust height as needed */
  object-fit: contain; /* Ensures the entire image fits inside */
  border-radius: 5px;
  border: 1px solid #ddd;
  padding: 5px;
  background: #fff;
}


/* Mobile: Stack images one by one */
@media (max-width: 768px) {
  .image-upload-section {
    flex-direction: column;
    align-items: center;
  }
}
.image-icon {
  position: relative;
  cursor: pointer;
}

.image-icon-btn {
  font-size: 0.9rem;
  color: #007bff;
}

.crazy-accordion .accordion-body {
  padding: 1.5rem;
}

.dayplan-crazy-container img {
  transition: transform 0.2s ease;
}

.dayplan-crazy-container img:hover {
  transform: scale(1.05);
}

.modal-body img {
  margin-bottom: 15px;
}
/* General Container for Day Plan */
.dayplan-crazy-container {
  padding: 20px;
  background-color: #f9f9f9;
}

/* Accordion Styling */
.crazy-accordion .accordion-item {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
}

.crazy-accordion .accordion-header {
  background-color: #f1f1f1;
  padding: 15px;
  border-bottom: 1px solid #ddd;
}

.crazy-accordion .accordion-body {
  background-color: #ffffff;
  padding: 15px;
}

.crazy-accordion .accordion-button {
  background-color: #f1f1f1;
  border: none;
  text-align: left;
}

.crazy-accordion .accordion-button:not(.collapsed) {
  background-color: #e9ecef;
}

/* Title and Icon for Lesson Type */
.crazy-accordion .lesson-title {
  font-size: 1.25rem;
  font-weight: bold;
  color: #333;
}

.crazy-accordion .lesson-type-badges {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.crazy-accordion .lesson-type-badge {
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: #007bff;
  color: white;
  border-radius: 20px;
  padding: 5px 10px;
  font-size: 0.9rem;
  cursor: pointer;
}

.crazy-accordion .lesson-type-badge.secondary {
  background-color: #6c757d;
}

.crazy-accordion .lesson-type-badge.success {
  background-color: #28a745;
}

.crazy-accordion .lesson-type-badge.warning {
  background-color: #ffc107;
}

/* Button Style for Image and Video Icons */
.image-icon-btn,
.video-icon-btn {
  font-size: 1rem;
  color: #007bff;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  text-decoration: underline;
  padding: 5px 10px;
  transition: color 0.3s ease, transform 0.3s ease;
}

.image-icon-btn:hover,
.video-icon-btn:hover {
  color: #0056b3;
  transform: scale(1.05);
}

.image-icon-btn:focus,
.video-icon-btn:focus {
  outline: none;
}

/* Image/Video Gallery Section Styling */
h6.fw-semibold {
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
}

.dayplan-crazy-container .mb-4 {
  margin-bottom: 30px;
}

/* Modal Styling for Image and Video Popups */
.modal-content {
  border-radius: 8px;
}

.modal-header {
  background-color: #007bff;
  color: white;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
}

.modal-title {
  font-size: 1.5rem;
}

.modal-body {
  padding: 20px;
}

.modal-body iframe {
  width: 100%;
  height: 315px;
  border: none;
  border-radius: 8px;
}

.modal-body img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.modal-footer {
  background-color: #f1f1f1;
  border-top: 1px solid #ddd;
  padding: 15px;
}

/* Styling for Button */
button.close {
  background-color: #f1f1f1;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 4px;
  color: #333;
  font-weight: 600;
  cursor: pointer;
}

button.close:hover {
  background-color: #e9ecef;
}

@media (max-width: 768px) {
  .crazy-accordion .lesson-title {
    font-size: 1.1rem;
  }

  .crazy-accordion .lesson-type-badge {
    font-size: 0.8rem;
    padding: 3px 8px;
  }

  .image-icon-btn,
  .video-icon-btn {
    font-size: 0.9rem;
  }

  .modal-body iframe {
    height: 250px;
  }

  .modal-body img {
    max-height: 200px;
  }
}
/* Accordion Body Custom Styling */
.accordion-body {
  background-color: #f8f9fa; /* Light background for better contrast */
  padding: 20px;
}

/* Section Titles (Image Galleries and Video Galleries) */
h6.fw-bold {
  font-size: 1.1rem;
  color: #343a40;
  margin-bottom: 1rem;
}

/* Gallery Section Title */
.gallery-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #495057;
  margin-bottom: 0.75rem;
}

/* Button Styles for Images and Videos */
.image-icon-btn,
.video-icon-btn {
  border-radius: 8px;
  padding: 10px 15px;
  transition: all 0.3s ease-in-out;
}

.image-icon-btn:hover,
.video-icon-btn:hover {
  background-color: #e0f7fa; /* Light blue hover effect */
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Icon Button Customization */
.image-icon-btn span,
.video-icon-btn span {
  font-size: 1rem;
  font-weight: 500;
}

/* Flexbox Layout for Buttons */
.d-flex.flex-wrap.gap-3 {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

/* Ensure a Responsive Design */
@media (max-width: 768px) {
  .gallery-section {
    margin-bottom: 1.5rem;
  }

  .gallery-title {
    font-size: 1rem;
  }

  .image-icon-btn,
  .video-icon-btn {
    font-size: 0.875rem;
    padding: 8px 12px;
  }
}

.lesson-type-badge {
  background-color: #f6a51f; /* Blue background */
  color: white; /* White text */
  padding: 5px 10px; /* Padding around the text */
  border-radius: 20px; /* Rounded corners */
  font-size: 0.875rem; /* Slightly smaller text */
  font-weight: bold; /* Make the text bold */
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); /* Light shadow for depth */
  display: inline-block; /* Make it inline so it fits within the content */
}
.image-carousel-modal .modal-content {
  background-color: rgba(0, 0, 0, 0.9);
  border: none;
  border-radius: 0;
}

.image-carousel-modal .modal-header {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  padding: 1rem;
}

.image-carousel-modal .close-button {
  color: white;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.image-carousel-modal .close-button:hover {
  opacity: 1;
}

.image-carousel-modal .modal-body {
  padding: 0;
  height: 100vh;
}

/* .image-container {
  max-width: 90%;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
} */

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  opacity: 0.7;
  transition: opacity 0.2s;
  z-index: 1;
  background: none;
  border: none;
  padding: 1rem;
}

.carousel-control:hover {
  opacity: 1;
  background: none;
  color: white;
}

.prev-button {
  left: 1rem;
}

.next-button {
  right: 1rem;
}

.image-counter {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 1.2rem;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0.5rem 1rem;
  border-radius: 20px;
}
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%; /* let it stretch full height */
  padding: 10px;
}

.carousel-image {
  max-width: 100%;
  max-height: 90vh; /* keep inside viewport */
  object-fit: contain; /* ensures no distortion */
}
`, "",{"version":3,"sources":["webpack://./src/views/utilities/dayPlan.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;;EAEA,2BAA2B;EAC3B;IACE,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC,4BAA4B,mBAAmB,EAAE,EAAE,eAAe;EAClE,4BAA4B,mBAAmB,EAAE,EAAE,eAAe;EAClE,4BAA4B,mBAAmB,EAAE,EAAE,iBAAiB;EACpE,4BAA4B,mBAAmB,EAAE,EAAE,iBAAiB;EACpE,4BAA4B,mBAAmB,EAAE,EAAE,gBAAgB;;EAEnE,oBAAoB;EACpB;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;;EAEA,oBAAoB;EACpB;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA,mBAAmB;EACnB;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,8BAA8B;IAC9B,qDAAqD;IACrD,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA,oBAAoB;AACpB;IACI,sBAAsB;IACtB,4CAA4C;AAChD;;AAEA,yBAAyB;AACzB,yCAAyC,0BAA0B,EAAE;AACrE,yCAAyC,0BAA0B,EAAE;AACrE,yCAAyC,0BAA0B,EAAE;AACrE,yCAAyC,0BAA0B,EAAE;AACrE,yCAAyC,0BAA0B,EAAE;;AAErE;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY,GAAG,2BAA2B;EAC1C,aAAa,EAAE,4BAA4B;EAC3C,mBAAmB,EAAE,yCAAyC;EAC9D,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;;AAGA,oCAAoC;AACpC;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;AACA,mCAAmC;AACnC;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;;EAEE,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;;EAEE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA,kCAAkC;AAClC;EACE,yBAAyB,EAAE,yCAAyC;EACpE,aAAa;AACf;;AAEA,yDAAyD;AACzD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB,EAAE,4BAA4B;EACvD,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,8BAA8B;AAC9B;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,YAAY,EAAE,eAAe;EAC7B,iBAAiB,EAAE,4BAA4B;EAC/C,mBAAmB,EAAE,oBAAoB;EACzC,mBAAmB,EAAE,0BAA0B;EAC/C,iBAAiB,EAAE,uBAAuB;EAC1C,0CAA0C,EAAE,2BAA2B;EACvE,qBAAqB,EAAE,iDAAiD;AAC1E;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY,EAAE,+BAA+B;EAC7C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB,EAAE,yBAAyB;EAC3C,mBAAmB,EAAE,0BAA0B;AACjD","sourcesContent":[".dayplan-container {\n    padding: 20px;\n    background: #f9f9f9;\n    min-height: 100vh;\n  }\n  \n  .dayplan-loader {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 40vh;\n    gap: 12px;\n    color: #64748b;\n    font-size: 0.95rem;\n  }\n  \n  .dayplan-empty {\n    min-height: 40vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 24px 16px;\n    color: #64748b;\n  }\n  \n  .dayplan-empty-icon {\n    font-size: 2.5rem;\n    margin-bottom: 8px;\n  }\n  \n  .dayplan-empty-title {\n    font-size: 1.3rem;\n    font-weight: 700;\n    color: #0f172a;\n    margin-bottom: 4px;\n  }\n  \n  .dayplan-empty-text {\n    font-size: 0.95rem;\n    max-width: 420px;\n  }\n  \n  .page-title {\n    font-size: 26px;\n    font-weight: bold;\n    color: #4a47a3;\n    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n    text-align: center;\n  }\n  \n  .custom-accordion {\n    max-width: 600px;\n    margin: 0 auto;\n  }\n  \n  .accordion-item {\n    border-radius: 10px;\n    overflow: hidden;\n    margin-bottom: 10px;\n    border: none;\n  }\n  \n  .accordion-header {\n    color: white;\n    font-weight: bold;\n    padding: 15px;\n    font-size: 18px;\n    text-transform: uppercase;\n    border-radius: 10px;\n    transition: 0.3s;\n  }\n  \n  .accordion-header:hover {\n    background:  #2ee543;\n  }\n  \n  .accordion-body {\n    background: white;\n    padding: 15px;\n    border-radius: 10px;\n  }\n  \n  /* 🟡 Vibrant Lesson Card */\n  .lesson-card {\n    border-radius: 12px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    padding: 15px;\n    transition: 0.3s;\n  }\n\n  /* 🔵 Random Background Colors */\n  .lesson-card:nth-child(1) { background: #ffebf0; } /* Light Pink */\n  .lesson-card:nth-child(2) { background: #e0f7fa; } /* Light Blue */\n  .lesson-card:nth-child(3) { background: #fff3e0; } /* Light Orange */\n  .lesson-card:nth-child(4) { background: #f3e5f5; } /* Light Purple */\n  .lesson-card:nth-child(5) { background: #e8f5e9; } /* Light Green */\n\n  /* 🟠 Hover Effect */\n  .lesson-card:hover {\n    transform: scale(1.02);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n  }\n  \n  /* 🎨 Lesson Title */\n  .lesson-title {\n    color: #d81b60;\n    font-size: 20px;\n    font-weight: bold;\n  }\n  \n  /* 📝 Lesson Plan */\n  .lesson-plan {\n    font-size: 16px;\n    font-weight: 500;\n    color: #444;\n    /* text-align: center; */\n    padding: 10px 15px;\n    border-left: 5px solid #ff6b6b;\n    background: linear-gradient(135deg, #fdfbfb, #ebedee);\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    margin-top: 10px;\n    transition: all 0.3s ease-in-out;\n}\n\n/* 🔥 Hover Effect */\n.lesson-plan:hover {\n    transform: scale(1.02);\n    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);\n}\n\n/* 🌀 Randomized Colors */\n.lesson-card:nth-child(1) .lesson-plan { border-left-color: #ff6b6b; }\n.lesson-card:nth-child(2) .lesson-plan { border-left-color: #4caf50; }\n.lesson-card:nth-child(3) .lesson-plan { border-left-color: #ff9800; }\n.lesson-card:nth-child(4) .lesson-plan { border-left-color: #3f51b5; }\n.lesson-card:nth-child(5) .lesson-plan { border-left-color: #e91e63; }\n\n.image-upload-section {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.image-upload {\n  text-align: center;\n}\n\n.preview-image {\n  width: 150px;  /* Adjust width as needed */\n  height: 150px; /* Adjust height as needed */\n  object-fit: contain; /* Ensures the entire image fits inside */\n  border-radius: 5px;\n  border: 1px solid #ddd;\n  padding: 5px;\n  background: #fff;\n}\n\n\n/* Mobile: Stack images one by one */\n@media (max-width: 768px) {\n  .image-upload-section {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n.image-icon {\n  position: relative;\n  cursor: pointer;\n}\n\n.image-icon-btn {\n  font-size: 0.9rem;\n  color: #007bff;\n}\n\n.crazy-accordion .accordion-body {\n  padding: 1.5rem;\n}\n\n.dayplan-crazy-container img {\n  transition: transform 0.2s ease;\n}\n\n.dayplan-crazy-container img:hover {\n  transform: scale(1.05);\n}\n\n.modal-body img {\n  margin-bottom: 15px;\n}\n/* General Container for Day Plan */\n.dayplan-crazy-container {\n  padding: 20px;\n  background-color: #f9f9f9;\n}\n\n/* Accordion Styling */\n.crazy-accordion .accordion-item {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n\n.crazy-accordion .accordion-header {\n  background-color: #f1f1f1;\n  padding: 15px;\n  border-bottom: 1px solid #ddd;\n}\n\n.crazy-accordion .accordion-body {\n  background-color: #ffffff;\n  padding: 15px;\n}\n\n.crazy-accordion .accordion-button {\n  background-color: #f1f1f1;\n  border: none;\n  text-align: left;\n}\n\n.crazy-accordion .accordion-button:not(.collapsed) {\n  background-color: #e9ecef;\n}\n\n/* Title and Icon for Lesson Type */\n.crazy-accordion .lesson-title {\n  font-size: 1.25rem;\n  font-weight: bold;\n  color: #333;\n}\n\n.crazy-accordion .lesson-type-badges {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.crazy-accordion .lesson-type-badge {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background-color: #007bff;\n  color: white;\n  border-radius: 20px;\n  padding: 5px 10px;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.crazy-accordion .lesson-type-badge.secondary {\n  background-color: #6c757d;\n}\n\n.crazy-accordion .lesson-type-badge.success {\n  background-color: #28a745;\n}\n\n.crazy-accordion .lesson-type-badge.warning {\n  background-color: #ffc107;\n}\n\n/* Button Style for Image and Video Icons */\n.image-icon-btn,\n.video-icon-btn {\n  font-size: 1rem;\n  color: #007bff;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  text-decoration: underline;\n  padding: 5px 10px;\n  transition: color 0.3s ease, transform 0.3s ease;\n}\n\n.image-icon-btn:hover,\n.video-icon-btn:hover {\n  color: #0056b3;\n  transform: scale(1.05);\n}\n\n.image-icon-btn:focus,\n.video-icon-btn:focus {\n  outline: none;\n}\n\n/* Image/Video Gallery Section Styling */\nh6.fw-semibold {\n  font-weight: 600;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n.dayplan-crazy-container .mb-4 {\n  margin-bottom: 30px;\n}\n\n/* Modal Styling for Image and Video Popups */\n.modal-content {\n  border-radius: 8px;\n}\n\n.modal-header {\n  background-color: #007bff;\n  color: white;\n  border-bottom: none;\n  border-radius: 8px 8px 0 0;\n}\n\n.modal-title {\n  font-size: 1.5rem;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-body iframe {\n  width: 100%;\n  height: 315px;\n  border: none;\n  border-radius: 8px;\n}\n\n.modal-body img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.modal-footer {\n  background-color: #f1f1f1;\n  border-top: 1px solid #ddd;\n  padding: 15px;\n}\n\n/* Styling for Button */\nbutton.close {\n  background-color: #f1f1f1;\n  border: 1px solid #ddd;\n  padding: 8px 16px;\n  border-radius: 4px;\n  color: #333;\n  font-weight: 600;\n  cursor: pointer;\n}\n\nbutton.close:hover {\n  background-color: #e9ecef;\n}\n\n@media (max-width: 768px) {\n  .crazy-accordion .lesson-title {\n    font-size: 1.1rem;\n  }\n\n  .crazy-accordion .lesson-type-badge {\n    font-size: 0.8rem;\n    padding: 3px 8px;\n  }\n\n  .image-icon-btn,\n  .video-icon-btn {\n    font-size: 0.9rem;\n  }\n\n  .modal-body iframe {\n    height: 250px;\n  }\n\n  .modal-body img {\n    max-height: 200px;\n  }\n}\n/* Accordion Body Custom Styling */\n.accordion-body {\n  background-color: #f8f9fa; /* Light background for better contrast */\n  padding: 20px;\n}\n\n/* Section Titles (Image Galleries and Video Galleries) */\nh6.fw-bold {\n  font-size: 1.1rem;\n  color: #343a40;\n  margin-bottom: 1rem;\n}\n\n/* Gallery Section Title */\n.gallery-title {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #495057;\n  margin-bottom: 0.75rem;\n}\n\n/* Button Styles for Images and Videos */\n.image-icon-btn,\n.video-icon-btn {\n  border-radius: 8px;\n  padding: 10px 15px;\n  transition: all 0.3s ease-in-out;\n}\n\n.image-icon-btn:hover,\n.video-icon-btn:hover {\n  background-color: #e0f7fa; /* Light blue hover effect */\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Icon Button Customization */\n.image-icon-btn span,\n.video-icon-btn span {\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n/* Flexbox Layout for Buttons */\n.d-flex.flex-wrap.gap-3 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n/* Ensure a Responsive Design */\n@media (max-width: 768px) {\n  .gallery-section {\n    margin-bottom: 1.5rem;\n  }\n\n  .gallery-title {\n    font-size: 1rem;\n  }\n\n  .image-icon-btn,\n  .video-icon-btn {\n    font-size: 0.875rem;\n    padding: 8px 12px;\n  }\n}\n\n.lesson-type-badge {\n  background-color: #f6a51f; /* Blue background */\n  color: white; /* White text */\n  padding: 5px 10px; /* Padding around the text */\n  border-radius: 20px; /* Rounded corners */\n  font-size: 0.875rem; /* Slightly smaller text */\n  font-weight: bold; /* Make the text bold */\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); /* Light shadow for depth */\n  display: inline-block; /* Make it inline so it fits within the content */\n}\n.image-carousel-modal .modal-content {\n  background-color: rgba(0, 0, 0, 0.9);\n  border: none;\n  border-radius: 0;\n}\n\n.image-carousel-modal .modal-header {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  padding: 1rem;\n}\n\n.image-carousel-modal .close-button {\n  color: white;\n  opacity: 0.8;\n  transition: opacity 0.2s;\n}\n\n.image-carousel-modal .close-button:hover {\n  opacity: 1;\n}\n\n.image-carousel-modal .modal-body {\n  padding: 0;\n  height: 100vh;\n}\n\n/* .image-container {\n  max-width: 90%;\n  max-height: 90vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.carousel-image {\n  max-width: 100%;\n  max-height: 90vh;\n  object-fit: contain;\n} */\n\n.carousel-control {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  color: white;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n  z-index: 1;\n  background: none;\n  border: none;\n  padding: 1rem;\n}\n\n.carousel-control:hover {\n  opacity: 1;\n  background: none;\n  color: white;\n}\n\n.prev-button {\n  left: 1rem;\n}\n\n.next-button {\n  right: 1rem;\n}\n\n.image-counter {\n  position: absolute;\n  bottom: 2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  color: white;\n  font-size: 1.2rem;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n}\n.image-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%; /* let it stretch full height */\n  padding: 10px;\n}\n\n.carousel-image {\n  max-width: 100%;\n  max-height: 90vh; /* keep inside viewport */\n  object-fit: contain; /* ensures no distortion */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
